import {
  GET_FORMATIONS,
  DELETE_FORMATION,
  SET_CURRENT_FORMATION,
} from "../actions/formations.actions";

const initialState = { list: [], current: null };

export default function formationsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FORMATIONS:
      return { ...state, list: action.payload };
    case DELETE_FORMATION:
      return { ...state, list: state.list.filter((f) => f.id !== action.payload.id) };
    case SET_CURRENT_FORMATION:
      return { ...state, current: action.payload };
    default:
      return state;
  }
}
